<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>核銷單審核</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>核銷管理</span></li>
          <li><span>核銷單審核</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="left">
              <div>查詢:
                <select v-model="search.year">
                  <option v-for="item in getNumbersDesc(nowYear, 108)" :key="item" :value="item">{{item}}</option>
                </select>　
                <select v-model="search.month">
                  <option v-for="item in 12" :key="item" :value="item">{{item}}</option>
                </select>
                <select v-model="search.workstudyType">
                  <option :value="null">請選擇</option>
                  <option :value="1">生活</option>
                  <option :value="2">聘雇</option>
                  <option :value="3">臨時</option>
                </select>　
                <select v-model="search.status">
                  <option :value="null">請選擇</option>
                  <option :value="false">未核銷</option>
                  <option :value="true">已核銷</option>
                </select>　
                身分證字號:<input type="text" v-model="search.idno" />
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="s_tenr" align="right">
                <a v-if="pageAdmin&&btnDisplay.bursary" href="#" @click.prevent="download('bursary')" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">生活助學金粘存單</a>
                <a v-if="pageAdmin&&btnDisplay.workstudy" href="#" @click.prevent="download('workstudy')" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">勞雇型工讀生(本薪)粘存單</a>
                <a v-if="pageAdmin&&btnDisplay.workstudy" href="#" @click.prevent="download('workstudy-labor')" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">勞雇型工讀生(勞退)粘存單</a>
                <a href="#" v-if="pageAdmin" @click.prevent="checkedSubmit" class="btn-upload btn btn-primary">確認核銷</a>
              </div>
              <table class="table table-no-more table-bordered table-striped mb-none" ref="table">
                <thead>
                  <tr>
                    <th class="text-center" width="3%">筆數</th>
                    <th class="text-center" width="3%" v-if="pageAdmin"><input type="checkbox" ref="allChecked" @change.prevent="allCheckedChange"></th>
                    <th class="text-center" width="5%">年/月份</th>
                    <th class="text-center" width="5%">類別</th>
                    <th class="text-center" width="10%">申請單位</th>
                    <th class="text-center" width="5%">姓名</th>
                    <th class="text-center" width="5%">學號</th>
                    <th class="text-center" width="5%">總時數</th>
                    <th class="text-center" width="5%">工作記錄</th>
                    <th class="text-center" width="5%">審核日期</th>
                    <th class="text-center" width="5%">是否核銷</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="筆數" class="text-center">{{index + 1}}</td>
                    <td data-title="核取方塊" class="text-center" v-if="pageAdmin">
                      <input type="checkbox" v-if="item.status==null" :value="item.workstudyId" @change.prevent="checkedChange">
                    </td>
                    <td data-title="年/月份" class="text-center">{{item.yearMonth}}</td>
                    <td data-title="類別" class="text-center">{{item.workstudyType}}</td>
                    <td data-title="申請單位" class="text-center">{{item.deptName}}</td>
                    <td data-title="姓名" class="text-center">{{item.studentName}}</td>
                    <td data-title="學號" class="text-center">{{item.studentId}}</td>
                    <td data-title="總時數" class="text-center">{{item.totalHours}}</td>
                    <td data-title="工作記錄" class="text-center">
                      <router-link v-if="item.workstudyType == '生活'" :to="'/workstudy/studyRecord/' + item.workstudyId + '?ym=' + search.year + '/' + search.month">學習記錄</router-link>
                      <router-link v-else :to="'/workstudy/workRecord/' + item.workstudyId + '?ym=' + search.year + '/' + search.month">工讀記錄</router-link>
                    </td>
                    <td data-title="審核日期" class="text-center">{{item.checkedDate}}</td>
                    <td data-title="是否核銷" class="text-center" style="color: #270;" v-if="item.status==true">已核銷</td>
                    <td data-title="是否核銷" class="text-center" style="color: #C00;" v-else-if="item.status==false">未核銷</td>
                    <td data-title="是否核銷" class="text-center" v-else></td>
                  </tr>
                </tbody>
              </table>
              
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import '../../mixins/pageAdmin'
export default {
  data() {
    return {
      nowYear: 108,
      search: {
        year: 0,
        month: 0,
        workstudyType: null,
        status: null,
        idno:"",
      },
      list: [],
      form: {
        workYear: null,
        workMonth: null,
        workstudyIdList: []
      },
      selectData: {},
      btnDisplay: {
        bursary: false,
        workstudy: false
      }
    };
  },
  mounted() {
    this.nowYear = this.nowDate().getFullYear() - 1911;
    this.searchClear();
    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table)
          .DataTable()
          .destroy();
      }
      this.$http
        .get("/api/verification/audit", {
          params: {
            year: this.search.year,
            month: this.search.month,
            workstudyType: this.search.workstudyType,
            status: this.search.status,
            idno: this.search.idno
          }
        })
        .then(a => {
          this.list = a.body;
          this.workstudyIdList = [];
          this.form.workYear = this.search.year;
          this.form.workMonth = this.search.month;
          this.selectData = Object.assign({}, this.search);
          if (!this.selectData.workstudyType) this.selectData.workstudyType = "";
          this.btnDisplay.bursary = this.list.some(a => a.workstudyType == "生活" && a.status == true);
          this.btnDisplay.workstudy = this.list.some(a => a.workstudyType != "生活" && a.status == true);
        });
    },
    searchSubmit() {
      this.load();
    },
    searchClear() {
      let d = this.nowDate();
      this.search.year = d.getFullYear() - 1911;
      this.search.month = d.getMonth();
      if (this.search.month == 0) {
        this.search.year--;
        this.search.month = 12;
      }
      this.search.workstudyType = null;
      this.search.status = null;
    },
    checkedChange(e) {
      let v = $(e.target).val();
      if ($(e.target).prop("checked") == true) {
        this.form.workstudyIdList.push(v);
      } else {
        $(this.$refs.allChecked).prop("checked", false);
        let i = this.form.workstudyIdList.indexOf(v);
        if (i > -1) this.form.workstudyIdList.splice(i, 1);
      }
    },
    allCheckedChange(e) {
      let checkboxList = $(this.$refs.table).find("tbody input[type=checkbox]");
      if ($(e.target).prop("checked") == true) {
        $(checkboxList).prop("checked", true);
        this.form.workstudyIdList = [];
        this.list.forEach(a => {
          if (a.status == null) this.form.workstudyIdList.push(a.workstudyId);
        });
      } else {
        $(checkboxList).prop("checked", false);
        this.form.workstudyIdList = [];
      }
    },
    checkedSubmit() {
      if (this.form.workstudyIdList.length < 1) {
        alert("尚未選取任何資料");
        return false;
      }
      if (!confirm("是否確認核銷？")) return false;
      this.$http.post("/api/verification/audit", this.form).then(a => {
        if (a.body.status) {
          alert("儲存成功");
          $(this.$refs.allChecked).prop("checked", false);
          this.load();
        } else {
          alert(a.body.msg);
          // console.log(a.body.exstr);
        }
      });
    },
    download(type) {
      let url = "";
      if (type == "bursary")
        url = "/api/verification/export-bursary?year=" + this.selectData.year + "&month=" + this.selectData.month;
      else if (type == "workstudy")
        url = "/api/verification/export-workstudy?year=" + this.selectData.year +
          "&month=" + this.selectData.month +
          "&workstudyType=" + this.selectData.workstudyType;
      else if (type == "workstudy-labor")
        url = "/api/verification/export-workstudy-labor?year=" + this.selectData.year +
          "&month=" + this.selectData.month +
          "&workstudyType=" + this.selectData.workstudyType;
      this.$http
        .post(url, {}, { responseType: "arraybuffer" })
        .then(res => {
          this.download2File(res);
        });
    }
  }
};
</script>

<style>
</style>